export const teams = [
	{
		id: 1,
		id: "panas",
		name: "Las Panas",
	},
	{
		id: 2,
		id: "aguilas",
		name: "Águilas",
	},
	{
		id: 3,
		id: "espartanas",
		name: "Espartanas",
	},
	{
		id: 4,
		id: "tropicales",
		name: "Tropicales",
	},
	{
		id: 5,
		id: "vikingas",
		name: "Vikingas",
	},
	{
		id: 6,
		id: "murallas",
		name: "Murallas",
	},
	{
		id: 7,
		id: "panteras",
		name: "Panteras",
	},
	{
		id: 8,
		id: 1,
		name: "1ro",
	},
	{
		id: 9,
		id: 2,
		name: "2do",
	},
	{
		id: 10,
		id: 3,
		name: "3ro",
	},
	{
		id: 11,
		id: 4,
		name: "4to",
	},
	{
		id: 12,
		name: "Clasificado a la Final",
	},
	{
		id: 13,
		name: "Clasificado a la Final",
	},
];

export const locations = [
	{
		id: 1,
		name: "Jarama",
		address: "Av. de San Sebastián, 15",
	},
];

export const locationTypes = {
	1: {
		icon: "map-pin",
		color: "secondary",
		label: "Jarama: Av. de San Sebastián, 15",
		link: "https://goo.gl/maps/gxmee9ZKVYunv4rB9",
	},
};

export const scoreTypes = {
	1: {
		abbrev: "PJ",
		color: "secondary",
		label: "Partidos jugados",
	},
	2: {
		abbrev: "PG",
		color: "secondary",
		label: "Partidos Ganados",
	},
	3: {
		abbrev: "PP",
		color: "secondary",
		label: "Partidos Perdidos",
	},
	4: {
		abbrev: "PE",
		color: "secondary",
		label: "Partidos Empatados",
	},
	5: {
		abbrev: "CF",
		color: "secondary",
		label: "Carreras a favor",
	},
	6: {
		abbrev: "CC",
		color: "secondary",
		label: "Carreras en contra",
	},
	7: {
		abbrev: "DIF",
		color: "secondary",
		label: "Diferencia",
	},
	8: {
		abbrev: "PTS",
		color: "secondary",
		label: "Puntos",
	},
};

export const events = [
	[
		{
			id: 1,
			homeclubId: "panas",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-04-03T09:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 8,
		},
		{
			id: 2,
			homeclubId: "tropicales",
			visitorId: "panteras",
			locationId: 1,
			date: "2022-04-03T11:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 11,
		},
		{
			id: 3,
			homeclubId: "murallas",
			visitorId: "vikingas",
			locationId: 1,
			date: "2022-04-03T13:10:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 7,
		},
	],
	[
		{
			id: 4,
			homeclubId: "panteras",
			visitorId: 3,
			locationId: 1,
			date: "2022-04-10T09:30:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 1,
		},
		{
			id: 5,
			homeclubId: "aguilas",
			visitorId: "murallas",
			locationId: 1,
			date: "2022-04-10T11:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 7,
		},
		{
			id: 6,
			homeclubId: "vikingas",
			visitorId: "tropicales",
			locationId: 1,
			date: "2022-04-10T13:10:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 3,
		},
	],
	[
		{
			id: 7,
			homeclubId: "tropicales",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-04-24T09:30:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 8,
			homeclubId: 3,
			visitorId: "vikingas",
			locationId: 1,
			date: "2022-04-24T11:20:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 9,
			homeclubId: "murallas",
			visitorId: "panas",
			locationId: 1,
			date: "2022-04-24T13:10:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
	],
	[
		{
			id: 10,
			homeclubId: "panas",
			visitorId: "tropicales",
			locationId: 1,
			date: "2022-05-08T09:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 2,
		},
		{
			id: 11,
			homeclubId: "aguilas",
			visitorId: 3,
			locationId: 1,
			date: "2022-05-08T11:20:00.000Z",
			scoreHomeclub: 5,
			scoreVisitor: 5,
		},
		{
			id: 12,
			homeclubId: "vikingas",
			visitorId: "panteras",
			locationId: 1,
			date: "2022-05-08T13:10:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 2,
		},
	],
	[
		{
			id: 13,
			homeclubId: "panteras",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-05-15T09:30:00.000Z",
			scoreHomeclub: 5,
			scoreVisitor: 6,
		},
		{
			id: 14,
			homeclubId: "tropicales",
			visitorId: "murallas",
			locationId: 1,
			date: "2022-05-15T11:20:00.000Z",
			scoreHomeclub: 10,
			scoreVisitor: 2,
		},
		{
			id: 15,
			homeclubId: "panas",
			visitorId: 3,
			locationId: 1,
			date: "2022-05-15T13:10:00.000Z",
			scoreHomeclub: 5,
			scoreVisitor: 4,
		},
		{
			id: 29,
			homeclubId: "tropicales",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-05-15T15:00:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 2,
		},
	],
	[
		{
			id: 16,
			homeclubId: "murallas",
			visitorId: 3,
			locationId: 1,
			date: "2022-05-22T09:30:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 14,
		},
		{
			id: 17,
			homeclubId: "panas",
			visitorId: "panteras",
			locationId: 1,
			date: "2022-05-22T11:20:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 10,
		},
		{
			id: 18,
			homeclubId: "aguilas",
			visitorId: "vikingas",
			locationId: 1,
			date: "2022-05-22T13:10:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 4,
		},
		{
			id: 30,
			homeclubId: "murallas",
			visitorId: "panas",
			locationId: 1,
			date: "2022-05-22T15:00:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 6,
		},
	],
	[
		{
			id: 19,
			homeclubId: "vikingas",
			visitorId: "panas",
			locationId: 1,
			date: "2022-05-29T09:30:00.000Z",
			scoreHomeclub: 6,
			scoreVisitor: 2,
		},
		{
			id: 20,
			homeclubId: 3,
			visitorId: "tropicales",
			locationId: 1,
			date: "2022-05-29T11:20:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 5,
		},
		{
			id: 21,
			homeclubId: "panteras",
			visitorId: "murallas",
			locationId: 1,
			date: "2022-05-29T13:10:00.000Z",
			scoreHomeclub: 10,
			scoreVisitor: 0,
		},
		{
			id: 31,
			homeclubId: 3,
			visitorId: "vikingas",
			locationId: 1,
			date: "2022-05-29T15:00:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 3,
		},
	],
	[
		{
			id: 22,
			homeclubId: "vikingas",
			visitorId: "panas",
			locationId: 1,
			date: "2022-06-05T10:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
		{
			id: 23,
			homeclubId: "panteras",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-06-05T12:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
	],
	[
		{
			id: 24,
			homeclubId: "vikingas",
			visitorId: "panas",
			locationId: 1,
			date: "2022-06-12T10:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
		{
			id: 25,
			homeclubId: "panteras",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-06-12T12:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
	],
	[
		{
			id: 26,
			homeclubId: "vikingas",
			visitorId: "panas",
			locationId: 1,
			date: "2022-06-19T10:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
		{
			id: 27,
			homeclubId: "panteras",
			visitorId: "aguilas",
			locationId: 1,
			date: "2022-06-19T12:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
	],
	[
		{
			id: 28,
			homeclubId: 12,
			visitorId: 13,
			locationId: 1,
			date: "2022-06-26T10:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
		},
	],
];
